export default function OrbitVisual() {
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[420px]">
      <div className="absolute -inset-8 rounded-full bg-gradient-to-br from-blue-600/10 to-violet-600/15 blur-2xl" aria-hidden="true" />
      <svg viewBox="0 0 420 420" className="relative h-full w-full" role="img" aria-label="Abstract orbit diagram">
        <defs>
          <linearGradient id="orbit-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563EB" />
            <stop offset="100%" stopColor="#7C3AED" />
          </linearGradient>
        </defs>
        {[60, 105, 150, 195].map((r) => (
          <circle key={r} cx="210" cy="210" r={r} fill="none" stroke="#E2E8F0" strokeWidth="1" />
        ))}
        <g className="spin-slow">
          <circle cx="210" cy="60" r="6" fill="#fff" stroke="url(#orbit-grad)" strokeWidth="2.5" />
          <circle cx="360" cy="210" r="4.5" fill="#2563EB" />
        </g>
        <g className="spin-reverse">
          <circle cx="210" cy="315" r="5" fill="#fff" stroke="url(#orbit-grad)" strokeWidth="2.5" />
          <circle cx="70" cy="210" r="4" fill="#7C3AED" />
          <circle cx="305" cy="105" r="3.5" fill="#2563EB" opacity="0.7" />
        </g>
      </svg>
      <div className="absolute left-1/2 top-1/2 grid h-24 w-24 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-3xl bg-gradient-to-br from-blue-600 to-violet-600 shadow-[0_30px_60px_-20px_rgba(37,99,235,0.55)]">
        <svg width="44" height="44" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M3.2 2.4h5a2.55 2.55 0 1 1 0 5.1h-5zM3.2 7.5h5.8a2.85 2.85 0 1 1 0 5.7H3.2z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
